module.exports = __webpack_public_path__ + "media/promo/hochland/images/bg-51b2db12ff33bbc1c25ce2aeb58fd654.png";